import { Button, Checkbox, Modal, Typography } from "antd";
import { default as React } from "react";

const { Title, Paragraph } = Typography;
const TermsModal = ({
  isModalVisible,
  handleCancel,
  onAgreeChange,
  isAgreed,
  onDone
}) => {
  return (
    <Modal
      title="Terms and Conditions Governing Acceptance of Deposits and Refund and Cancellation Policy"
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={[]}
      width={900}
    >
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <Title level={5}>Minimum Deposit:</Title>
        <Paragraph>
          Deposits will be accepted in multiples of Rs.1,000/- subject to a
          minimum amount of...
        </Paragraph>

        <Title level={5}>Scheme and Tenure:</Title>
        <Paragraph>
          Company accepts cumulative and non-cumulative deposits for different
          tenures as mentioned on the first page of the application form.
        </Paragraph>

        <Title level={5}>Interest:</Title>
        <Paragraph>
          Interest rate is fixed for the entire period of deposit. Interest will
          be computed on Cumulative deposit from the date of deposit (date of
          realization) until March 31st...
        </Paragraph>
      </div>
      <Checkbox onChange={onAgreeChange}>
        <Paragraph>
          I have read and agree to the Terms & Conditions as well as the Refund
          & Cancellation Policy.
        </Paragraph>
      </Checkbox>
      <div className="d-flex justify-center">
        <button className="send-btn" disabled={!isAgreed} onClick={onDone}>
          Done
        </button>
      </div>
    </Modal>
  );
};

export default TermsModal;
